import { useState, useEffect } from 'react'
import * as contactoService from '../servicios/contactoService'
import Banderas from './Banderas'
import styles from './Contacto.module.css'
import InfoContacto from './InfoContacto'
import MensajeContacto from './MensajeContacto'

const Contacto = () => {
  const [contacto, setContacto] = useState([])
  // const [epais, setEpais] = useState(null)

  const traerDatos = async (pais) => {
    // setEpais(pais)
    const { data: cons } = await contactoService.buscarTodos(pais)
    setContacto(cons)
  }

  useEffect(() => {
    const fetchContacto = async () => {
      const { data: con } = await contactoService.buscarTodos('AR')
      setContacto(con)
    }

    fetchContacto()
  }, [])

  return (
    <div className="pageCard pageCard--conMargenInferior">
      <div className={styles.headerRow}>
        <h4 className={styles.pageTitle}>Contacto</h4>
        <Banderas traerDatos={traerDatos} />
      </div>
      <div className={styles.grid}>
        <MensajeContacto />
        <InfoContacto contacto={contacto} />
      </div>
    </div>
  )
}

export default Contacto
